export default __webpack_public_path__ + "static/media/dtsd5168-1.d2559fca.png";